import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const Ribbon = ({styleName}) => {

    return (
        <Tooltip title={"This is a Key Risk Indicator (KRI), one of the most critical indications of your cybersecurity risk from the attacker's perspective."}>
            <div className="ribbon ribbon-bottom-left">
                <span>KRI</span>
            </div>
        </Tooltip>
    )
};

export default Ribbon;

Ribbon.propTypes = {
};
